import React, { useContext, useEffect, useState } from 'react';
import { DispatchContext, StateContext } from 'context';
import './nosotros.css';
import { Themes } from 'styles';
import { faBriefcase, faCheck, faFile, faHandshake, faPlus, faTimes, faUniversity, faUserTie } from '@fortawesome/free-solid-svg-icons';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EqualHeight, EqualHeightElement } from 'react-equal-height';
import { Accordion, AccordionDetails, AccordionSummary, Box, IconButton, Modal, Tab, Tabs, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {
    GestionIntegralRiesgosCobranzas, PoliticaControlInterno, PoliticaGobiernoTi,
    CodigoEtica, Resolucion7Acta78, Resolucion16GobiernoCorporativo1, Resolucion17Acta62TasasDeInteres,
    Resolucion23Acta9, Resolucion30Acta17DeFecha31032022, ReglamentoDirectorio
} from 'assets/docs';
import Viewer from './viewer';
import { useScrollBlock } from 'hooks';
import { AppActions } from 'store';
import { Api } from 'services';
import { Helper } from 'utils';
import CONFIG from 'config';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: 1020,
    bgcolor: 'background.paper',
    borderRadius: 4,
    boxShadow: 24,
    p: 1,
};


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Nosotros = (props) => {
    const state = useContext(StateContext);
    const dispatch = useContext(DispatchContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    const [expanded, setExpanded] = useState(0);
    const [documento, setDocumento] = useState({ filePath: null, fileType: null });
    const [modalDocumento, setModalDocumento] = useState(false);
    const [blockScroll, allowScroll] = useScrollBlock();

    const [tasas, setTasas] = useState([]);


    const [tabGobiernoValue, setTabGobiernoValue] = useState(0);
    const [tabTasasValue, setTabTasasValue] = useState(0);

    useEffect(() => {
        var options = {
            url: Api.route('/nosotros/tasas/tasa_anual_producto'),
            method: 'GET'
        };
        Api.request(options, response => {
            Helper.log('get tasas response', response);
            if (response.codigo && response.codigo !== 200) {
            } else if (response.codigo && response.codigo === 200) {
                let productos = [];
                let pr = '';
                response.datos.forEach(producto => {                    
                    if (producto.IDINTERESPRODUCTO === 1) {
                        pr = producto.INP_TASA_ANUAL + '%';
                        productos.push({
                            id: 1,
                            tipoDeOperacion: "PRESTAMOS PERSONALES",
                            monto: "500.000",
                            tasa: pr.replace('.', ',')
                        });
                    } else if (producto.IDINTERESPRODUCTO === 2) {
                        pr = producto.INP_TASA_ANUAL + '%';
                        productos.push({
                            id: 2,
                            tipoDeOperacion: "DESCUENTO DE CHEQUES",
                            monto: "300.000",
                            tasa: pr.replace('.', ',')
                        });
                    }
                });   
                setTasas(productos);
            }
        }, error => {
            Helper.log('error get tasas', error);
        });
    }, []);


    const handleChange = (expandedPanel) => (event, newXpandedPanel) => {
        if (expandedPanel === expanded) {
            expandedPanel = 0;
        }
        setExpanded(expandedPanel);
        console.log(documento);
    };

    const handleOpenDocumento = () => setModalDocumento(true);
    const handleCloseDocumento = () => {
        setModalDocumento(false);
        allowScroll();
    };

    const valores = [
        {
            id: 1,
            icono: faHandshake,
            titulo: "Calidad de Servicio al Cliente",
            texto: "Brindar atención personalizada, ágil y profesional, identificando las necesidades de los clientes, para mejorar y crear nuevos productos y servicios a costos competitivos."
        },
        {
            id: 2,
            icono: faUniversity,
            titulo: "Ética",
            texto: "Desarrollar nuestras actividades con honestidad, rectitud, integridad, confidencialidad y solvencia moral."
        },
        {
            id: 3,
            icono: faBriefcase,
            titulo: "Seguridad",
            texto: "Generar confianza en el servicio integral a los clientes; protección a los colaboradores, bienes y sistemas de información de la institución."
        },
        {
            id: 4,
            icono: faUserTie,
            titulo: "Recursos Humanos",
            texto: "Recompensar el desempeño y la superación de todos los colaboradores; fortalecer la comunicación interna, creando un espíritu de equipo, capacitación continua y un comportamiento de lealtad y fidelidad con la institución."
        },
    ];
    const accionistas = [
        {
            id: 1,
            nombre: "Gustavo Adolfo Díaz Cardozo",
            nacionalidad: "Paraguaya",
            participacion: "40%"
        },
        {
            id: 2,
            nombre: "Grisela Azucena Fiorio Aguayo",
            nacionalidad: "Paraguaya",
            participacion: "40%"
        },
        {
            id: 3,
            nombre: "Claudia Romina Díaz Fiorio",
            nacionalidad: "Paraguaya",
            participacion: "10%"
        },
        {
            id: 4,
            nombre: "Luis Bernardo Díaz Fiorio",
            nacionalidad: "Paraguaya",
            participacion: "10%"
        },
    ];
    const planaDirectiva = [
        {
            id: 1,
            nombre: "Gustavo Adolfo Díaz Cardozo",
            cargo: "Presidente"
        },
        {
            id: 2,
            nombre: "Grisela Azucena Fiorio Aguayo",
            cargo: "Vicepresidente"
        },
        {
            id: 3,
            nombre: "Claudia Romina Díaz Fiorio",
            cargo: "Directora"
        },
        {
            id: 4,
            nombre: "Luis Bernardo Díaz Fiorio",
            cargo: "Director"
        },
    ];

    const planaEjecutiva = [
        {
            id: 1,
            nombre: "Luis Díaz",
            experiencia: "13",
            domicilio: "Asunción",
            cargo: "Gerente General"
        },
        {
            id: 2,
            nombre: "Blas Gaona",
            experiencia: "20",
            domicilio: "Asunción",
            cargo: "Gerente de Riesgos y Cobranzas"
        },
        {
            id: 3,
            nombre: "Ángel Figueredo",
            experiencia: "10",
            domicilio: "Villa Elisa",
            cargo: "Gerente de T.I."
        },
        {
            id: 4,
            nombre: "Lorenzo Caballero",
            experiencia: "20",
            domicilio: "Asunción",
            cargo: "Gerente Comercial"
        },
    ];
    const politicas = [
        {
            id: 1,
            nombre: "Gestión integral de riesgos y cobranzas",
            filePath: GestionIntegralRiesgosCobranzas,
            fileType: 'pdf'
        },
        {
            id: 2,
            nombre: "Política de control interno",
            filePath: PoliticaControlInterno,
            fileType: 'pdf'
        },
        {
            id: 3,
            nombre: "Política de gobierno T.I.",
            filePath: PoliticaGobiernoTi,
            fileType: 'pdf'
        }
    ];
    const reglamentaciones = [
        {
            id: 1,
            nombre: "Código de ética",
            filePath: CodigoEtica,
            fileType: 'pdf'
        },
        {
            id: 2,
            nombre: "Reglamento Directorio",
            filePath: ReglamentoDirectorio,
            fileType: 'pdf'
        }
    ];
    const resoluciones = [
        {
            id: 1,
            nombre: "Resolucion 7 - Acta 78",
            filePath: Resolucion7Acta78,
            fileType: 'pdf'
        },
        {
            id: 2,
            nombre: "Resolucion 16 - Gobierno Corporativo 1",
            filePath: Resolucion16GobiernoCorporativo1,
            fileType: 'pdf'
        },
        {
            id: 3,
            nombre: "Resolucion 17 - Acta 62 - Tasas De Interes",
            filePath: Resolucion17Acta62TasasDeInteres,
            fileType: 'pdf'
        },
        {
            id: 4,
            nombre: "Resolucion 23 - Acta 9",
            filePath: Resolucion23Acta9,
            fileType: 'pdf'
        },
        {
            id: 5,
            nombre: "Resolucion 30 - Acta 17 - De Fecha 31/03/2022",
            filePath: Resolucion30Acta17DeFecha31032022,
            fileType: 'pdf'
        }
    ];
    // const tasas = [
    //     {
    //         id: 1,
    //         tipoDeOperacion: "PRESTAMOS PERSONALES",
    //         monto: "500.000",
    //         tasa: '30,38%'
    //     },
    //     {
    //         id: 2,
    //         tipoDeOperacion: "DESCUENTO DE CHEQUES",
    //         monto: "300.000",
    //         tasa: '30,38%'
    //     }
    // ];
    const comisionesGastos = [
        {
            id: 1,
            gasto: "RE DEPOSITO DE CHEQUES",
            monto: "50.000"
        },
        {
            id: 2,
            gasto: "AVISO DE CHEQUES DEVUELTOS",
            monto: "50.000"
        },
        {
            id: 3,
            gasto: "PEDIDO DE RETENCION DE CHEQUES A DEPOSITAR",
            monto: "50.000"
        },
        {
            id: 4,
            gasto: "IN SITU RADIO DE HASTA 30 KM",
            monto: "25.000"
        },
        {
            id: 5,
            gasto: "IN SITU RADIO DE  HASTA 50 KM",
            monto: "35.000"
        }
    ];

    const comisionesCobranzas = [
        {
            id: 1,
            gasto: "EMISION DE NOTAS DE RECLAMOS",
            monto: "15.000"
        },
        {
            id: 2,
            gasto: "NOTIFICACIONES",
            monto: "20.000"
        },
        {
            id: 3,
            gasto: "TELEGRAMAS COLACIONADOS",
            monto: "25.000"
        },
        {
            id: 4,
            gasto: "SERVICIO DE COBRADORES",
            monto: "10.000"
        },
        {
            id: 5,
            gasto: "LLAMADAS DE RECLAMOS",
            monto: "5.000"
        },
        {
            id: 6,
            gasto: "NOTIFICACIONES FUERA DEL AREA CAPITAL",
            monto: "25.000"
        }
    ];

    const verDocumento = (doc) => {
        setDocumento(doc);
        setModalDocumento(true);
        console.log('doc', doc);
        document.body.style.overflow = "hidden";
        blockScroll();
    }
    const cerrarModalDocumento = (event) => {
        setModalDocumento(false);
        document.body.style.overflow = "scroll";
        allowScroll();
    }

    const handleChangeTabTasa = (event, newValue) => {
        setTabTasasValue(newValue);
    };

    const handleChangeTabGobierno = (event, newValue) => {
        setTabGobiernoValue(newValue);
    };


    return (
        <>
            <div id="nosotros" className="w3-block">
                <div className="w3-block empresa">
                    <div className="w3-content">
                        <div className="w3-block w3-center titulo bs-bbox">
                            <h1>La empresa</h1>
                        </div>
                        <div className="textos bs-bbox">
                            <div className="w3-padding" style={{ maxWidtfh: '720px', margin: 'auto' }}>
                                <p><span>S<span className="minuscula-empresa">ER</span>F<span className="minuscula-empresa">IN</span></span> nace en 1995 con el objetivo de ofrecer soluciones dinámicas para distintos tipos de clientes y necesidades, tales como financiación para pequeñas y medianas empresas, proyectos personales, turismo, emprendimientos comerciales, etc.</p>
                                <p><span>S<span className="minuscula-empresa">ER</span>F<span className="minuscula-empresa">IN</span></span> te ofrece el dinero en efectivo que necesitás. Sin muchos trámites, sin garantes, sin moverte de tu casa u oficina, y con la máxima reserva.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w3-content">
                    <div className="w3-row w3-center textos-mision-vision">
                        <div className="w3-col l6 w3-padding bs-bbox">
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                <div className="w3-block w3-center titulo bs-bbox">
                                    <h1 style={{ color: Themes[indexTema].TH }}>Misión</h1>
                                </div>
                                <p><span>S<span className="minuscula">ER</span>F<span className="minuscula">IN</span></span>, es una empresa financiera dirigida a satisfacer las necesidades, de Clientes tanto físicos como Jurídicos, a quienes de una u otra manera se le dificulta el acceso al crédito, ofreciendo soluciones ágiles, menos burocráticas, seguras y confiables, con excelente atención personalizada, cordial, cálida y amable.</p>
                            </AnimationOnScroll>
                        </div>
                        <div className="w3-col l6 w3-padding bs-bbox">
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                <div className="w3-block w3-center titulo bs-bbox">
                                    <h1 style={{ color: Themes[indexTema].TH }}>Visión</h1>
                                </div>
                                <p>Ser la empresa financiera de referencia en el mercado paraguayo por la calidad y eficiencia, reconocida por su solidez ética, innovación y confiabilidad, por la atención personalizada que ofrecemos a los clientes para satisfacer sus necesidades, generando un compromiso permanente con la comunidad ofreciendo respuestas efectivas en un mercado cada vez más competitivo.</p>
                            </AnimationOnScroll>
                        </div>
                    </div>
                </div>
                <div id="valores">
                    <div className="w3-content">
                        <div className="w3-block w3-center titulo">
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                <h1 style={{ color: Themes[indexTema].TH }}>Nuestros valores</h1>
                            </AnimationOnScroll>
                        </div>
                        <EqualHeight>
                            <div className="w3-row row-valores">
                                {valores.map((valor) => <div key={valor.id} className="w3-col col-valores">
                                    <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                        <div>
                                            <div className="icon-container">
                                                <div className="card-up">

                                                </div>
                                                <div className="circulo">
                                                    <FontAwesomeIcon icon={valor.icono} color={"#ffffff"} className="icono" />
                                                </div>
                                            </div>
                                            <div className="text-container">
                                                <EqualHeightElement name="Name">
                                                    <div className="w3-block">

                                                        <h3>{valor.titulo}</h3>
                                                        <span>{valor.texto}</span>

                                                    </div>
                                                </EqualHeightElement>
                                            </div>
                                        </div>
                                    </AnimationOnScroll>
                                </div>)
                                }
                            </div>
                        </EqualHeight>
                        <div className="w3-round-xxlarge w3-white w3-padding" style={{ marginTop: 80, marginBottom: 60 }}>
                            <div className="w3-block w3-center titulo w3-margin-top">
                                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                    <h1 style={{ color: Themes[indexTema].TH }}>Transparencia Informativa</h1>
                                </AnimationOnScroll>
                            </div>
                            <div style={{ paddingBottom: 30 }}>

                                <Accordion expanded={expanded === 1} onChange={handleChange(1)}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="1-bh-content" id="1-bh-header">
                                        <h3 style={{ color: Themes[indexTema].TH }}>Gobierno Corporativo</h3>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box sx={{ width: '100%' }}>
                                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                                <Tabs variant="scrollable" scrollButtons="auto" value={tabGobiernoValue} onChange={handleChangeTabGobierno} aria-label="basic tabs example">
                                                    <Tab label="PLANA DIRECTIVA" {...a11yProps(0)} />
                                                    <Tab label="PLANA EJECUTIVA" {...a11yProps(1)} />
                                                </Tabs>
                                            </Box>
                                            <TabPanel value={tabGobiernoValue} index={0}>
                                                <TableContainer component={Paper}>
                                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ color: Themes[indexTema].TH }}>Nombre</TableCell>
                                                                <TableCell style={{ color: Themes[indexTema].TH }}>Cargo</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {planaDirectiva.map((row) => (
                                                                <TableRow
                                                                    key={row.id}
                                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                >
                                                                    <TableCell component="th" scope="row">
                                                                        {row.nombre}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row">
                                                                        {row.cargo}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </TabPanel>
                                            <TabPanel value={tabGobiernoValue} index={1}>
                                                <TableContainer component={Paper}>
                                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ color: Themes[indexTema].TH }}>Nombre</TableCell>
                                                                <TableCell style={{ color: Themes[indexTema].TH }}>Años de experiencia</TableCell>
                                                                <TableCell style={{ color: Themes[indexTema].TH }}>Domicilio</TableCell>
                                                                <TableCell style={{ color: Themes[indexTema].TH }}>Cargo</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {planaEjecutiva.map((row) => (
                                                                <TableRow
                                                                    key={row.id}
                                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                >
                                                                    <TableCell component="th" scope="row">
                                                                        {row.nombre}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row">
                                                                        {row.experiencia}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row">
                                                                        {row.domicilio}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row">
                                                                        {row.cargo}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </TabPanel>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 2} onChange={handleChange(2)}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="2-bh-content" id="2-bh-header">
                                        <h3 style={{ color: Themes[indexTema].TH }}>Accionistas</h3>
                                    </AccordionSummary>
                                    <AccordionDetails className="w3-light-gray">
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ color: Themes[indexTema].TH }}>Nombre</TableCell>
                                                        <TableCell style={{ color: Themes[indexTema].TH }}>Nacionalidad</TableCell>
                                                        <TableCell style={{ color: Themes[indexTema].TH }}>% de participación</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {accionistas.map((row) => (
                                                        <TableRow
                                                            key={row.id}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                        >
                                                            <TableCell component="th" scope="row">
                                                                {row.nombre}
                                                            </TableCell>
                                                            <TableCell component="th" scope="row">
                                                                {row.nacionalidad}
                                                            </TableCell>
                                                            <TableCell component="th" scope="row">
                                                                {row.participacion}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 3} onChange={handleChange(3)}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="3-bh-content" id="3-bh-header">
                                        <h3 style={{ color: Themes[indexTema].TH }}>Políticas</h3>
                                    </AccordionSummary>
                                    <AccordionDetails className="w3-light-gray">
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                <TableBody>
                                                    {politicas.map((row) => (
                                                        <TableRow hover className="cursor-pointer"
                                                            onClick={() => verDocumento(row)}
                                                            key={row.id}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                            <TableCell component="th" scope="row">
                                                                <FontAwesomeIcon icon={faFile} color={Themes[indexTema].TH} size="2x" />&nbsp;&nbsp;&nbsp;{row.nombre}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 4} onChange={handleChange(4)}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="4-bh-content" id="4-bh-header">
                                        <h3 style={{ color: Themes[indexTema].TH }}>Reglamentaciones</h3>
                                    </AccordionSummary>
                                    <AccordionDetails className="w3-light-gray">
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                <TableBody>
                                                    {reglamentaciones.map((row) => (
                                                        <TableRow hover className="cursor-pointer"
                                                            onClick={() => verDocumento(row)}
                                                            key={row.id}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                            <TableCell component="th" scope="row">
                                                                <FontAwesomeIcon icon={faFile} color={Themes[indexTema].TH} size="2x" />&nbsp;&nbsp;&nbsp;{row.nombre}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 5} onChange={handleChange(5)}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="5-bh-content" id="5-bh-header">
                                        <h3 style={{ color: Themes[indexTema].TH }}>Resoluciones y Actas BCP</h3>
                                    </AccordionSummary>
                                    <AccordionDetails className="w3-light-gray">
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                <TableBody>
                                                    {resoluciones.map((row) => (
                                                        <TableRow hover className="cursor-pointer"
                                                            onClick={() => verDocumento(row)}
                                                            key={row.id}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                            <TableCell component="th" scope="row">
                                                                <FontAwesomeIcon icon={faFile} color={Themes[indexTema].TH} size="2x" />&nbsp;&nbsp;&nbsp;{row.nombre}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 6} onChange={handleChange(6)}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="6-bh-content" id="6-bh-header">
                                        <h3 style={{ color: Themes[indexTema].TH }}>Tasas y tarifarios</h3>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box sx={{ width: '100%' }}>
                                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                                <Tabs variant="scrollable" scrollButtons="auto" value={tabTasasValue} onChange={handleChangeTabTasa} aria-label="basic tabs example">
                                                    <Tab label="TASAS Y TARIFARIOS VIGENTES" {...a11yProps(0)} />
                                                    <Tab label="TARIFARIO DE COMISIONES Y GASTOS ADM" {...a11yProps(1)} />
                                                    <Tab label="GASTOS DE COBRANZAS" {...a11yProps(2)} />
                                                </Tabs>
                                            </Box>
                                            <TabPanel value={tabTasasValue} index={0}>
                                                <TableContainer component={Paper}>
                                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ color: Themes[indexTema].TH }}>TIPO DE OPERACIÓN</TableCell>
                                                                <TableCell style={{ color: Themes[indexTema].TH }} align="right">MONTO DESDE GS.</TableCell>
                                                                <TableCell style={{ color: Themes[indexTema].TH }} align="right">TASA ANUAL</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {tasas.map((row) => (
                                                                <TableRow
                                                                    key={row.id}
                                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                >
                                                                    <TableCell component="th" scope="row">
                                                                        {row.tipoDeOperacion}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" align="right">
                                                                        <b>{row.monto}</b>
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" align="right">
                                                                        <b>{row.tasa}</b>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </TabPanel>
                                            <TabPanel value={tabTasasValue} index={1}>
                                                <TableContainer component={Paper} >
                                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ color: Themes[indexTema].TH }}>GASTOS Y SERVICIOS ASOCIADOS </TableCell>
                                                                <TableCell style={{ color: Themes[indexTema].TH }} align="right">MONTO HASTA GS.</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {comisionesGastos.map((row) => (
                                                                <TableRow
                                                                    key={row.id}
                                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                >
                                                                    <TableCell component="th" scope="row">
                                                                        {row.gasto}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" align="right">
                                                                        <b>{row.monto}</b>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </TabPanel>
                                            <TabPanel value={tabTasasValue} index={2}>
                                                <TableContainer component={Paper} >
                                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                        <TableBody>
                                                            {comisionesCobranzas.map((row) => (
                                                                <TableRow
                                                                    key={row.id}
                                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                >
                                                                    <TableCell component="th" scope="row">
                                                                        {row.gasto}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" align="right">
                                                                        <b>{row.monto}</b> Gs.
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </TabPanel>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    open={modalDocumento}
                    onClose={handleCloseDocumento}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    disableScrollLock={true}>
                    <Box sx={style}>
                        <div className="w3-row">
                            <div className="w3-col w3-right" style={{ width: '50px' }}>
                                <IconButton aria-label="delete" onClick={cerrarModalDocumento}>
                                    &nbsp;<FontAwesomeIcon icon={faTimes} color={'#3A3A3A'} />&nbsp;
                                </IconButton>
                            </div>
                            <div className="w3-rest w3-center">
                                {/* <a href={} className="w3-btn w3-xlarge">Descargar</a> */}
                            </div>
                        </div>
                        <div className="w3-padding-large bs-bbox w3-light-gray" style={{ height: 600, overflowY: 'scroll' }}>
                            <div key={Math.random()}>
                                <Viewer fileType={documento.fileType} filePath={documento.filePath} />
                            </div>
                        </div>
                    </Box>
                </Modal>
            </div >
        </>
    );
}
export default Nosotros;